export const EMPTY_MEMBER = { name: "", callSign: "", email: "" };

export const getRankColor = (rank) => {
  switch (rank) {
    case 1: return "from-amber-400 via-amber-500 to-amber-600";
    case 2: return "from-gray-300 via-gray-400 to-gray-500";
    case 3: return "from-amber-600 via-amber-700 to-amber-800";
    default: return "from-[#00A38A] via-[#00A38A] to-[#008570]";
  }
};

export const getRankBadge = (rank) => {
  switch (rank) {
    case 1: return "🥇";
    case 2: return "🥈";
    case 3: return "🥉";
    default: return `#${rank}`;
  }
};

export const gridClass = (count) => {
  if (count >= 2) return `md:grid-cols-2 lg:grid-cols-${Math.min(count, 4)}`;
  return "md:grid-cols-2";
};

// Only show placeholders if we have fewer than 2 members
export const placeholderCount = (count) => (count < 2 ? 2 - count : 0);

export const initials = (name) => (name || "").split(" ").map((n) => n[0]).join("");
